module.exports = __webpack_public_path__ + "static/media/Comfortaa-Light.88bcfc7a.woff2";